import { NameSpacing } from '../../../NonReact/utils/NameSpacing'

export enum TelSysTabsFields {
    DETAILS = 'details',
    COMMUNICATIONS = 'communications',
    SYNC = 'sync',
    DEFAULT_SITE_SETTINGS = 'defaultSiteSettings',
    LICENCE_MANAGEMENT = 'licenseManagement',
    ADVANCED = 'advanced'
}

enum TelSysDetailsFields {
    ID = 'id',
    DESCRIPTION = 'description',
    TAGS = 'tags',
    BILLING_ID = 'billingID',
    BILLABLE = 'billable',
    TRIAL = 'trial',
    CME = 'cme',
    ECCR_REPLACEMENT = 'eccrReplacement',
    AI_ASSIST_ENABLED = 'aiAssistEnabled',
    MFA = 'mfa'
}

enum CommunicationsFields {
    TYPE = 'type',
    TEL_SYS_PROFILE = 'telSysProfile',
    SIMULATION_MODE = 'simulationMode',
    LICENCED_FOR = 'licencedFor',
    DELETE_ACD_AGENTS = 'deleteACDAgents',
    IP_ADDRESS1 = 'ipAddress1',
    XSP_SERVER = 'xspServer',
    IP_ADDRESS2 = 'ipAddress2',
    TCP_PORT1 = 'tcpPort1',
    USER_NAME1 = 'userName1',
    PASSWORD1 = 'password1',
    TCP_PORT2 = 'tcpPort2',
    IP_ADDRESS4 = 'ipAddress4',
    TCP_PORT4 = 'tcpPort4',
    USE_SSLTLS2 = 'useSSLTLS2',
    USER_NAME2 = 'userName2',
    PASSWORD2 = 'password2',
    OAUTH_SESSION_ID = 'oauthSessionID',
    USE_SSLTLS4 = 'useSSLTLS4',
    USER_NAME4 = 'userName4',
    PASSWORD4 = 'password4',
    COMMS_PARAMETER_TEXT1 = 'commsParameterText1',
    COMMS_PARAMETER_TEXT2 = 'commsParameterText2',
    IP_ADDRESS3 = 'ipAddress3',
    USER_NAME3 = 'userName3',
    PASSWORD3 = 'password3',
    COMMS_ENABLED = 'commsEnabled',
    IN_SERVICE = 'inService',
    MS_TEAMS_MODE_TYPE = 'msTeamsModeType',
    INTEGRATION_MODE = 'integrationMode',
    INTEGRATION_TYPE = 'integrationType',
    SYNC_ENV_ON_SETUP = 'syncEnvOnSetup',
    CP_MONITORED_CQ_ENABLED = 'cpMonitoredCQEnabled',
    BUSINESS_OPTIONS = 'businessOptions'
}

enum TelSysSynchronisationFields {
    SYNC_NOW = 'syncNow',
    LAST_SYNC = 'lastSync'
}

enum TelSysDefaultSiteSettingsFields {
    TIMEZONE = 'timezone',
    COUNTRY_CODE = 'countryCode',
    INTERNAL_DIGIT_LENGTH = 'internalDigitLength',
    OUTBOUND_TEL_NO_PREFIX = 'outboundTelNoPrefix',
    RECORDING_INTEGRATION = 'recordingIntegration',
    E164_ENABLED = 'e164Enabled'
}

enum LicenseManagementFields {
    ESSENTIALS = 'essentials',
    PROFESSIONAL = 'professional',
    ENTERPRISE = 'enterprise',
    CALL_CENTRE_AGENT = 'callCentreAgent',
    CALL_CENTRE_SUPERVISOR = 'callCentreSupervisor',
    CX_INTEGRATION = 'cxIntegration'
}

enum AdvancedFields {
    PARTITION_COUNT_MAX = 'partitionCountMax',
    SCHEDULED_REPORTS_ALLOWED_PER_USER = 'scheduledReportsAllowedPerUser',
    SCHEDULED_EMAILS_ALLOWED_PER_REPORT = 'scheduledEmailsAllowedPerReport',
    CTI_LOG_INC_CLASS_NAMES = 'ctiLogIncClassNames',
    INTERNAL_DIAG_DUMP_ENABLED = 'internalDiagDumpEnabled',
    CALL_MODEL_DIAG_DUMP_ENABLED = 'callModelDiagDumpEnabled',
    CTI_LOG_ENABLED = 'ctiLogEnabled',
    PARTITIONS_RPTING_SCOPE_ALL_ENABLED = 'partitionsRptingScopeAllEnabled',
    CALL_MODEL_DIAG_DUMP_ENABLED_FOR_DEV = 'callModelDiagDumpEnabledForDev',
    CTI_CALL_MODEL_LOG_ENABLED = 'ctiCallModelLogEnabled',
    USER_NOTIFICATIONS_ENABLED = 'userNotificationsEnabled',
    EXTENSIONS_PER_ENTERPRISE_USER = 'extensionsPerEnterpriseUser',
    MAX_USER_SYNC = 'maximumAllowedUsersSync',
    MAX_MONITORED_USERS = 'maximumAllowedUsersMonitored'
}

export const detailsNamespacing = (fieldName: TelSysDetailsFields): string =>
    NameSpacing(TelSysTabsFields.DETAILS, fieldName)
export const communicationsNamespacing = (fieldName: CommunicationsFields): string =>
    NameSpacing(TelSysTabsFields.COMMUNICATIONS, fieldName)
export const synchronisationNamespacing = (fieldName: TelSysSynchronisationFields): string =>
    NameSpacing(TelSysTabsFields.SYNC, fieldName)
export const defaultSiteSettingsNamespacing = (fieldName: TelSysDefaultSiteSettingsFields): string =>
    NameSpacing(TelSysTabsFields.DEFAULT_SITE_SETTINGS, fieldName)
export const licenceManagementNameSpacing = (fieldName: LicenseManagementFields): string =>
    NameSpacing(TelSysTabsFields.LICENCE_MANAGEMENT, fieldName)
export const advancedNamespacing = (fieldName: AdvancedFields): string =>
    NameSpacing(TelSysTabsFields.ADVANCED, fieldName)

export const ID_FIELD_NAME: string = detailsNamespacing(TelSysDetailsFields.ID)
export const DESCRIPTION_FIELD_NAME: string = detailsNamespacing(TelSysDetailsFields.DESCRIPTION)
export const TAGS_FIELD_NAME: string = detailsNamespacing(TelSysDetailsFields.TAGS)
export const BILLING_ID_FIELD_NAME: string = detailsNamespacing(TelSysDetailsFields.BILLING_ID)
export const BILLABLE_FIELD_NAME: string = detailsNamespacing(TelSysDetailsFields.BILLABLE)
export const TRIAL_FIELD_NAME: string = detailsNamespacing(TelSysDetailsFields.TRIAL)
export const CME_FIELD_NAME: string = detailsNamespacing(TelSysDetailsFields.CME)
export const ECCR_REPLACEMENT_FIELD_NAME: string = detailsNamespacing(TelSysDetailsFields.ECCR_REPLACEMENT)
export const AI_ASSIST_ENABLED_FIELD_NAME: string = detailsNamespacing(TelSysDetailsFields.AI_ASSIST_ENABLED)
export const MFA_FIELD_NAME: string = detailsNamespacing(TelSysDetailsFields.MFA)

export const TYPE_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.TYPE)
export const TEL_SYS_PROFILE_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.TEL_SYS_PROFILE)
export const SIMULATION_MODE_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.SIMULATION_MODE)
export const LICENCED_FOR_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.LICENCED_FOR)
export const DELETE_ACD_AGENTS_NAME: string = communicationsNamespacing(CommunicationsFields.DELETE_ACD_AGENTS)
export const IP_ADDRESS1_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.IP_ADDRESS1)
export const XSP_SERVER_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.XSP_SERVER)
export const IP_ADDRESS2_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.IP_ADDRESS2)
export const TCP_PORT1_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.TCP_PORT1)
export const USER_NAME1_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.USER_NAME1)
export const PASSWORD1_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.PASSWORD1)
export const TCP_PORT2_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.TCP_PORT2)
export const IP_ADDRESS3_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.IP_ADDRESS3)
export const USER_NAME3_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.USER_NAME3)
export const PASSWORD3_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.PASSWORD3)
export const IP_ADDRESS4_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.IP_ADDRESS4)
export const TCP_PORT4_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.TCP_PORT4)
export const USE_SSLTLS2_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.USE_SSLTLS2)
export const USER_NAME2_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.USER_NAME2)
export const PASSWORD2_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.PASSWORD2)
export const OAUTH_SESSION_ID_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.OAUTH_SESSION_ID)
export const USE_SSLTLS4_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.USE_SSLTLS4)
export const USER_NAME4_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.USER_NAME4)
export const PASSWORD4_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.PASSWORD4)
export const COMMS_PARAMETER_TEXT1_FIELD_NAME: string = communicationsNamespacing(
    CommunicationsFields.COMMS_PARAMETER_TEXT1
)
export const COMMS_PARAMETER_TEXT2_FIELD_NAME: string = communicationsNamespacing(
    CommunicationsFields.COMMS_PARAMETER_TEXT2
)
export const MS_TEAMS_MODE_TYPE_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.MS_TEAMS_MODE_TYPE)
export const INTEGRATION_MODE_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.INTEGRATION_MODE)
export const INTEGRATION_TYPE_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.INTEGRATION_TYPE)
export const SYNC_ENV_ON_SETUP: string = communicationsNamespacing(CommunicationsFields.SYNC_ENV_ON_SETUP)
export const CP_MONITORED_CQ_ENABLED_FIELD_NAME: string = communicationsNamespacing(
    CommunicationsFields.CP_MONITORED_CQ_ENABLED
)
export const BUSINESS_OPTIONS_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.BUSINESS_OPTIONS)
export const COMMS_ENABLED_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.COMMS_ENABLED)
export const IN_SERVICE_FIELD_NAME: string = communicationsNamespacing(CommunicationsFields.IN_SERVICE)
export const SYNC_NOW_FIELD_NAME: string = synchronisationNamespacing(TelSysSynchronisationFields.SYNC_NOW)
export const LAST_SYNC_FIELD_NAME: string = synchronisationNamespacing(TelSysSynchronisationFields.LAST_SYNC)
export const TIMEZONE_FIELD_NAME: string = defaultSiteSettingsNamespacing(TelSysDefaultSiteSettingsFields.TIMEZONE)
export const E164_ENABLED_FIELD_NAME: string = defaultSiteSettingsNamespacing(
    TelSysDefaultSiteSettingsFields.E164_ENABLED
)
export const COUNTRY_CODE_FIELD_NAME: string = defaultSiteSettingsNamespacing(
    TelSysDefaultSiteSettingsFields.COUNTRY_CODE
)
export const INTERNAL_DIGIT_LENGTH_FIELD_NAME: string = defaultSiteSettingsNamespacing(
    TelSysDefaultSiteSettingsFields.INTERNAL_DIGIT_LENGTH
)
export const OUTBOUND_TEL_NO_PREFIX_FIELD_NAME: string = defaultSiteSettingsNamespacing(
    TelSysDefaultSiteSettingsFields.OUTBOUND_TEL_NO_PREFIX
)
export const RECORDING_INTEGRATION_FIELD_NAME: string = defaultSiteSettingsNamespacing(
    TelSysDefaultSiteSettingsFields.RECORDING_INTEGRATION
)

export const ESSENTIALS_LICENSE_FIELD_NAME: string = licenceManagementNameSpacing(LicenseManagementFields.ESSENTIALS)
export const PROFESSIONAL_LICENSE_FIELD_NAME: string = licenceManagementNameSpacing(
    LicenseManagementFields.PROFESSIONAL
)
export const ENTERPRISE_LICENSE_FIELD_NAME: string = licenceManagementNameSpacing(LicenseManagementFields.ENTERPRISE)
export const CALL_CENTRE_AGENT_LICENSE_FIELD_NAME: string = licenceManagementNameSpacing(
    LicenseManagementFields.CALL_CENTRE_AGENT
)
export const CALL_CENTRE_SUPERVISOR_LICENSE_FIELD_NAME: string = licenceManagementNameSpacing(
    LicenseManagementFields.CALL_CENTRE_SUPERVISOR
)
export const CX_INTEGRATION_LICENSE_FIELD_NAME: string = licenceManagementNameSpacing(
    LicenseManagementFields.CX_INTEGRATION
)

export const PARTITION_COUNT_MAX_FIELD_NAME: string = advancedNamespacing(AdvancedFields.PARTITION_COUNT_MAX)
export const SCHEDULED_REPORTS_ALLOWED_PER_USER_NAME: string = advancedNamespacing(
    AdvancedFields.SCHEDULED_REPORTS_ALLOWED_PER_USER
)
export const SCHEDULED_EMAILS_ALLOWED_PER_REPORT_NAME: string = advancedNamespacing(
    AdvancedFields.SCHEDULED_EMAILS_ALLOWED_PER_REPORT
)
export const MAX_USER_SYNC_FIELD_NAME: string = advancedNamespacing(AdvancedFields.MAX_USER_SYNC)
export const MAX_MONITORED_USERS_FIELD_NAME: string = advancedNamespacing(AdvancedFields.MAX_MONITORED_USERS)
export const PARTITIONS_RPTING_SCOPE_ALL_ENABLED_FIELD_NAME: string = advancedNamespacing(
    AdvancedFields.PARTITIONS_RPTING_SCOPE_ALL_ENABLED
)
export const EXTENSIONS_PER_ENTERPRISE_USER_FIELD_NAME: string = advancedNamespacing(
    AdvancedFields.EXTENSIONS_PER_ENTERPRISE_USER
)
export const CTI_LOG_INC_CLASS_NAMES_FIELD_NAME: string = advancedNamespacing(AdvancedFields.CTI_LOG_INC_CLASS_NAMES)
export const INTERNAL_DIAG_DUMP_ENABLED_FIELD_NAME: string = advancedNamespacing(
    AdvancedFields.INTERNAL_DIAG_DUMP_ENABLED
)
export const CTI_LOG_ENABLED_FIELD_NAME: string = advancedNamespacing(AdvancedFields.CTI_LOG_ENABLED)
export const CALL_MODEL_DIAG_DUMP_ENABLED_FOR_DEV_FIELD_NAME: string = advancedNamespacing(
    AdvancedFields.CALL_MODEL_DIAG_DUMP_ENABLED_FOR_DEV
)
export const CTI_CALL_MODEL_LOG_ENABLED_FIELD_NAME: string = advancedNamespacing(
    AdvancedFields.CTI_CALL_MODEL_LOG_ENABLED
)
export const USER_NOTIFICATIONS_ENABLED_FIELD_NAME: string = advancedNamespacing(
    AdvancedFields.USER_NOTIFICATIONS_ENABLED
)
